<template>
  <div class="goods_index">
    <div class="shop_top">
      <shop-top :subnav_show="false" :change_color="true"></shop-top>
    </div>
    <div class="breadcrumb width_center_1200">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item :to="{ path: '/user/index' }">{{ lang.user_center }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ lang.points_mall }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="goods_where width_center_1200">
      <el-tabs v-model="params.pontares" @tab-click="handleTab">
        <el-tab-pane
          v-for="(item, index) in tabsData.list"
          :key="index"
          :label="item.name"
          :name="item.value"
        ></el-tab-pane>
      </el-tabs>
      <div class="right-action">
        <div class="item" @click="$router.push('/user/record?current=0')">
          <svg-icon iconClass="integral" />
          <div class="cont">
            <div class="title">{{ lang.integral }}</div>
            <div class="num">{{ user.integral }}</div>
          </div>
        </div>
        <div class="item" @click="$router.push('/user/record?current=1')">
          <svg-icon iconClass="record" />
          <div class="cont">
            <div class="title">{{ lang.exchange_record }}</div>
            <div class="more flex-align">
              {{ lang.check }}
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="width_center_1200">
      <div v-if="banner.advImg" class="banner">
        <el-image :src="banner.advImg"></el-image>
      </div>
      <div v-if="list.length" class="goods-list">
        <div class="item" v-for="item in list" :key="item.id" @click="$router.push(`/points/detail?id=${item.id}&ptype=${item.ptype}`)">
          <el-image :src="item.homeimg" fit="cover"></el-image>
          <p class="name">{{ item.name }}</p>
          <div class="bottom">
            <div class="num">{{ item.integral }}{{ lang.integral }}</div>
						<div class="btn">{{ lang.exchange }}</div>
          </div>
        </div>
        <div class="pick" v-for="item in list" :key="item.id"></div>
      </div>
      <el-empty v-else :description="lang.no_data"></el-empty>
    </div>

    <div class="home_fy_block width_center_1200">
      <el-pagination
        @current-change="changePage"
        background
        layout="prev, pager, next,jumper,total"
        :total="total"
        :page-size="params.pageSize"
        :current-page="params.pageNum"
      ></el-pagination>
    </div>

    <merchant-promise></merchant-promise>
    <shop-foot></shop-foot>
    <!-- vue 回到顶部 -->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ShopTop from '@/components/ShopHead/index'
import ShopFoot from '@/components/ShopFoot/index.vue'
import MerchantPromise from '@/components/MerchantPromise/index'
import { getadvList, getdicdtabykey } from '@/api/home'
import { getintegralproduct } from '@/api/product'
import { getbuyexchangeorderpay } from '@/api/order'
export default {
  components: {
    ShopTop,
    ShopFoot,
    MerchantPromise
  },
  data() {
    return {
      tabsData: {
        list: [],
      },
      banner: {},
      params: {
        name: '',
        pontares: '',
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      list: [],
      noList: false
    }
  },
  computed: {
    ...mapGetters(['isLogin', 'user', 'unit']),
    lang() {
      return this.$t('points')
    }
  },
  async created() {
    this.getBanner()
    this.getTabs()
  },
  methods: {
    getBanner() {
      getadvList({
        platform: 3,
        advPosition: 6
      }).then(({ data }) => {
        if (data.length) {
          this.banner = data[0]
        }
      })
    },
    getTabs() {
      getdicdtabykey({ groupname: 'pointkey' }).then(({ data }) => {
        data.splice(0, 1)
				this.tabsData.list = data
        this.params.pontares = data[0].value
        this.getList()
      })
    },
    async getList() {
      const { data } = await getintegralproduct(this.params)
      this.total = data.count
      this.list = data.data
    },
    changePage(val) {
      this.params.pageNum = val
      this.getList()
    },
    handleTab(val) {
      this.params.pontares = val.name
      this.getList()
    },
    async handleExchange(id, ptype, buynum) {
      this.$confirm(this.lang.tips_content, this.lang.tips, {
        confirmButtonText: this.lang.confirm_text,
        cancelButtonText: this.lang.cancel_text
      }).then(() => {
        getbuyexchangeorderpay({ id, ptype, buynum }).then(res => {
          if (res.code === 1) {
            this.$message.success(res.msg)
            this.$store.dispatch('updateUserInfo')
          }
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.breadcrumb {
  margin: 18px auto 15px;
}
.banner {
  margin-bottom: 20px;
  .el-image {
    width: 1200px;
    height: 120px;
  }
}
.goods_where {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  margin: 0 auto 20px;
  /deep/ .el-tabs__header {
    margin: 0;
  }
  /deep/ .el-tabs__nav-wrap::after {
    display: none;
  }
  /deep/ .el-tabs__item.is-active {
    color: #4f4f4f;
  }
  /deep/ .el-tabs__active-bar {
    background-color: #ec9221;
  }
  /deep/ .el-tabs__item:hover {
    color: #ec9221;
  }
  /deep/ .el-tabs__item {
    text-align: center;
    min-width: 109px;
    height: 46px;
    line-height: 46px;
    color: #4f4f4f;
    padding: 0;
    font-size: 12px;
  }
  .el-tabs {
    flex: 1;
  }
  .right-action {
    display: flex;
    align-items: center;
    .item {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-right: 20px;
      .cont {
        display: flex;
        align-items: center;
        margin-left: 8px;
        .title {
          color: #4F4F4F;
          font-size: 14px;
          padding-right: 4px;
        }
        .num {
          color: #EC9221;
          font-size: 14px;
        }
        .more {
          color: #EC9221;
          font-size: 12px;
        }
      }
    }
  }
}
.goods-list {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .pick {
    width: 284px;
    overflow: hidden;
  }
  .item {
    width: 284px;
    margin-bottom: 20px;
    &:hover {
      cursor: pointer;
    }
    .el-image {
      width: 284px;
      height: 284px;
    }
    .name {
      padding: 10px 0 15px;
      color: #4F4F4F;
      font-size: 14px;
    }
    .bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .num {
        color: #EC9221;
        font-size: 14px;
      }
      .btn {
        text-align: center;
        width: 48px;
        line-height: 22px;
        border: 1px solid #ec9221;
        border-radius: 30px;
        color: #EC9221;
        font-size: 14px;
      }
    }
  }
}
</style>